export default class UserProvider {

    static myInstance = null;

    uiFilial = "";
    dadosUsuario = null;
    cdPessoa = "";
    cdFilial = "";
    menus = [];

    static getInstance() {
        if (UserProvider.myInstance == null) {
            UserProvider.myInstance = new UserProvider();
        }

        return UserProvider.myInstance;
    }

    getUiFilial() {

        var ui = this.uiFilial;
        if(ui === "" && localStorage.getItem("uiFilial") !== ""){
            ui = localStorage.getItem("uiFilial");
        }

        return ui;
    }

    setUiFilial(id) {
        this.uiFilial = id;
        localStorage.setItem("uiFilial", id);
    }

    getDadosUsuario() {

        var dadosUsuario = this.dadosUsuario;
        
        if ( (dadosUsuario === null || dadosUsuario === "") && localStorage.getItem("dadosUsuario") !== "") {
            dadosUsuario = JSON.parse(localStorage.getItem("dadosUsuario"));
        }
        
        return dadosUsuario;
    }

    setDadosUsuario(dadosUsuario) {
        
        this.dadosUsuario = dadosUsuario;
        localStorage.setItem("dadosUsuario", JSON.stringify(dadosUsuario));                              
    }

    getCdPessoa() {

        var ui = this.cdPessoa;
        if(ui === "" && localStorage.getItem("cdPessoa") !== ""){
            ui = localStorage.getItem("cdPessoa");
        }

        return ui;
    }

    setCdPessoa(id) {
        this.cdPessoa = id;
        localStorage.setItem("cdPessoa", id);
    }

    getCdFilial() {

        var ui = this.cdFilial;
        if(ui === "" && localStorage.getItem("cdFilial") !== ""){
            ui = localStorage.getItem("cdFilial");
        }

        return ui;
    }

    setCdFilial(id) {
        this.cdFilial = id;
        localStorage.setItem("cdFilial", id);
    }

    getMenusOcultos(){
        if(this.menus.length === 0 && localStorage.getItem("dadosUsuario") !== ""){
            var dadosUsuarios = JSON.parse(localStorage.getItem("dadosUsuario"));

            if(dadosUsuarios != null && "DsMenus" in dadosUsuarios){
                var arrMenus = JSON.parse(dadosUsuarios["DsMenus"]);

                for(var i=0; i < arrMenus.length; i++){
                    if(arrMenus[i]["stAtivo"] == 0)
                        this.menus.push(arrMenus[i]["cdMenu"]);
                }
            }
        }

        return this.menus;
    }
}


// WEBPACK FOOTER //
// ./src/js/userProvider.js